
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import { Board, ChangeBoardOwnerRequest } from '../../backend/backendapi';
import { handleError } from '../../../api';
import vSelect from 'vue-select';
import { WindowType } from '../../../util';

declare var window: WindowType;

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: { vSelect },
})
export default class ChangeBoardOwnerModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  board: Board | null = null;
  userId: string | null = null;

  get users(): { id: string, name: string }[] {
    return this.state.users
        .filter(e => e.id !== window.application.user.id)
        .map(e => ({ id: e.id!, name: (e.firstName ?? '') + ' ' + (e.lastName ?? '') }));
  }

  public open(board: Board): void {
    this.board = board;
    this.userId = null!;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  async changeOwner(): Promise<void> {
    if (!this.board || !this.userId) {
      return;
    }
    const board = this.board;
    try {
      await this.state.boardAPI.updateOwner(new ChangeBoardOwnerRequest({ boardId: board.id!, userId: this.userId }));
      this.$toasted.info(this.$t('kanban.board.changeOwner.modal.boardOwnershipTransferred').toString());

      const index = this.state.boards.findIndex(e => e.id === board!.id);
      if (index > -1) {
        this.state.boards.splice(index, 1);
      }
      
      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    }
  }
}
